import { render, staticRenderFns } from "./global-transactions-details-response.vue?vue&type=template&id=0de3b250&"
import script from "./global-transactions-details-response.vue?vue&type=script&lang=js&"
export * from "./global-transactions-details-response.vue?vue&type=script&lang=js&"
import style0 from "./global-transactions-details-response.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports